import React from 'react';
import _ from 'lodash';

/*
Give a component the ability to respond to its own rendered width.

Usage:
	export default React.createClass({
		mixins: [ResponsiveElement],
		breakpoints: {
			small: e => e.width < 600,
			medium: e => e.width >= 600,
		},
		render() {
			const breakpoints = this.state.breakpoints;
			...
		}
	});
*/

export default {
	_rawSetRespWidth() {
		try {
			var node = React.findDOMNode(this);
		} catch(e) {
			return
		}
		const element = {width: node.offsetWidth};
		const breakpoints = _.mapValues(this.breakpoints, b => b(element));
		if (!this.state || !_.isEqual(breakpoints, this.state.breakpoints)) {
			this.setState({breakpoints});
		}
	},
	componentDidMount() {
		this._setRespWidth = _.debounce(this._rawSetRespWidth, 250, {leading: true}).bind(this);
		window.addEventListener('resize', this._setRespWidth);
		this._setRespWidth();
	},
	componentDidUpdate() {
		this._setRespWidth();
	},
	componentWillUnmount() {
		window.removeEventListener('resize', this._setRespWidth);
	},
};



/** WEBPACK FOOTER **
 ** core/client/rawr/layout/ResponsiveElementMixin.js
 **/